export default function(instance) {
  return {
    get(id) {
      return instance.get(`/api/v2/news/${id}`)
    },
    getAll(params) {
      return instance.get(`/api/v2/news/`, { params })
    },
  }
}